import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    const scrollableComponents = document.getElementsByClassName('outer-container');
    scrollableComponents[0].scrollTo(0, 0);
  }, [pathname]);
}

export default ScrollToTop;